import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import Avatar from '@mui/material/Avatar';
import { FC } from 'react';
import { SxProps } from '@mui/system';

type TLazyAvatar = {
  src: string,
  alt: string
  sx?: SxProps & {
    width?: number | string
    height?: number | string
  }
};

const LazyAvatar: FC<TLazyAvatar> = ({ src, alt, sx = {} }) => (
  <Avatar sx={{ ...sx }}>
    <LazyLoadImage
      width={sx?.width}
      height={sx?.height}
      alt={alt}
      src={src}
      effect="blur"
    />
  </Avatar>
);

export { LazyAvatar };
